/**
 * A2A Class Service
 * Wraps class operations using A2A client instead of direct Supabase calls
 */

import { A2AClient } from '../client.js';
import { getAuthToken } from '../authHelper.js';

// Initialize A2A client with default backend URL and authentication
const a2aClient = new A2AClient(
  process.env.REACT_APP_A2A_BACKEND_URL || process.env.REACT_APP_API_URL || 'https://a2amyclassai-server.appsokay.net',
  'myclass-client-classes',
  {
    secretKey: process.env.REACT_APP_A2A_SECRET_KEY,
    enableLogging: process.env.NODE_ENV === 'development',
    getAuthToken: getAuthToken
  }
);

/**
 * A2A Class Service
 */
export const a2aClassService = {
  /**
   * Get classes
   */
  async getClasses(params) {
    const { tenantId, formLevel, page = 1, limit = 50 } = params;
    
    const result = await a2aClient.executeTask('list_classes', {
      tenant_id: tenantId,
      form_level: formLevel,
      page,
      limit
    });

    return {
      success: result.success,
      data: result.data || [],
      pagination: result.pagination
    };
  },

  /**
   * Get class by ID
   */
  async getClassById(classId, tenantId) {
    const result = await a2aClient.executeTask('get_class', {
      tenant_id: tenantId,
      class_id: classId
    });

    return {
      success: result.success,
      data: result.data
    };
  },

  /**
   * Create class
   */
  async createClass(classData) {
    const result = await a2aClient.executeTask('create_class', {
      tenant_id: classData.tenant_id,
      class_data: classData
    });

    return {
      success: result.success,
      data: result.data
    };
  },

  /**
   * Update class
   */
  async updateClass(classId, tenantId, classData) {
    const result = await a2aClient.executeTask('update_class', {
      tenant_id: tenantId,
      class_id: classId,
      class_data: classData
    });

    return {
      success: result.success,
      data: result.data
    };
  },

  /**
   * Delete class
   */
  async deleteClass(classId, tenantId) {
    const result = await a2aClient.executeTask('delete_class', {
      tenant_id: tenantId,
      class_id: classId
    });

    return {
      success: result.success
    };
  }
};

export default a2aClassService;

